<template>
  <div class="shipping-preview">
    <a-spin :spinning="loading" :tip="tip" size="large">
      <div class="main">
        <TopBar
          :list="list"
          :selectedList="getSelectedGoods"
          :categoryList="categoryList"
          :needUpdateList="needUpdateList"
          @delete-goods="deleteGoods"
          @select-all="selectAllGoods"
          @update-goods-category="updateGoodsCategory"
        />
        <GoodsItem
          ref="goodsItem"
          v-for="(item, index) in list"
          :tabs="itemTabActivityList"
          :currentCheckedItem="currentCheckedItem"
          :key="item"
          :class="{ 'is-selected': item.selected, row: true }"
          :goods="item"
          :index="index"
          :categoryList="categoryList"
          @delete-goods="deleteGoods"
          @change-checked-goods="changeCheckedGoods"
          @change-is-update-data="changeIsUpdateData"
        />
      </div>
    </a-spin>
    <div v-show="list.length" class="footer-affix">
      <a-button type="primary" :loading="loading" @click="startMove">开始铺货</a-button>
    </div>
    <a-modal
      class="move-log-modal"
      v-model:visible="isShowLogModal"
      width="900px"
      style="top: 35px"
      :maskClosable="false"
    >
      <template #title>
        <div style="margin-bottom: 3px">铺货日志</div>
        <MoveSteps :current="2" />
      </template>
      <LogModal ref="logModal" strType="p" />
      <template #footer>
        <a-button type="primary" v-show="!loading && !isOutUse" @click="openLogPage">打开上货列表，查看记录</a-button>
        <a-button type="primary" v-show="!isOutUse" ghost @click="isShowLogModal = false">关闭窗口</a-button>
        <slot name="footer" />
      </template>
    </a-modal>
    <a-back-top style="right: 50px; bottom: 60px" :target="backTopTarget" />
    <SignSplitModal ref="SignSplitModal"></SignSplitModal>
  </div>
</template>
<script>
import TopBar from "./components/top_bar";
import GoodsItem from "./components/goods_item";
import handler from "./handler";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { createVNode, h } from "vue";
import { Modal } from "ant-design-vue";
import LogModal from "@/views/base/components/log_modal/log_modal";
import SignSplitModal from "@/views/base/components/sign_split_modal";
import MoveSteps from "@/views/moving_function/components/move_steps";
import newSkuUtil from "@/views/moving_function/utils/sku/index";
export default {
  components: { TopBar, GoodsItem, LogModal, MoveSteps, SignSplitModal },
  props: {
    activeKey: {
      type: String,
      default: "preview",
    },
    isOutUse: {
      type: Boolean,
    },
  },
  data() {
    return {
      tip: "正在加载中，请耐心等待。",
      list: [],
      categoryList: [],
      allCategoryList: [],
      loading: false,
      isShowLogModal: false,
      needUpdateList: [],
      currentCheckedItem: {},
      itemTabActivityList: [
        { label: "基础信息", value: "BaseInfo" },
        // { label: '商品类目', value: 'GoodsCategory' },
        { label: "SKU信息", value: "SkuInfo" },
        { label: "详情图", value: "GoodsDetailImage" },
      ],
      itemClass: ".shipping-preview .main .goods-item",
      mainClass: ".shipping-preview .main",
    };
  },
  computed: {
    getSelectedGoods() {
      return this.list?.length ? this.list.filter((item) => item?.selected) : [];
    },
  },
  methods: {
    // 切换全选
    selectAllGoods(value) {
      this.list.map((item) => {
        item.selected = value;
      });
    },
    // 删除商品
    deleteGoods(goodsId) {
      handler.DeleteGoods(this, goodsId);
    },
    // 改变当前选中的商品
    changeCheckedGoods(item) {
      this.currentCheckedItem = item;
      const index = this.list.findIndex((obj) => obj.id === item.id);
      handler.ScrollIntoView(
        document.querySelectorAll(this.itemClass)[index],
        document.querySelector(this.mainClass),
        this.needUpdateList.length
      );
    },
    changeIsUpdateData(item) {
      // 如果当前选中的刚好是点击已修改, 那么要把下一个变成已选中, 同时也要改变滚动条
      if (this.currentCheckedItem.id === item.id) {
        const index = this.list.findIndex((obj) => obj.id === item.id);
        this.currentCheckedItem = this.list[index + 1];
        this.currentCheckedItem &&
          handler.ScrollIntoView(
            document.querySelectorAll(this.itemClass)[index + 1],
            document.querySelector(this.mainClass),
            this.needUpdateList.length
          );
      }
    },
    // 获取店铺里的分类
    getFirstCategoryList() {
      handler.GetFirstCategoryList(this);
    },
    // 获取标题长度
    getTitleLength(title) {
      return handler.GetTitleLength(title);
    },
    // 打开上货列表
    async openLogPage() {
      const result = await handler.getUserInfo();
      if (result.Account.SignSplitStatus != "valid") {
        this.$refs.SignSplitModal.open();
      }

      this.isShowLogModal = false;
      this.$emit("open-log-page");
    },
    //清空铺货预览列表
    clearShippingList() {
      this.currentCheckedItem = [];
      this.list = [];
    },
    //注入铺货预览列表
    setShippingList(list) {
      this.list.push(...list);
      this.currentCheckedItem = { ...this.list[0] };
    },
    // 开始铺货前提示
    showConfirm(content, idList) {
      return new Promise((resolve) => {
        Modal.confirm({
          title: `温馨提示，${this.list.length} 个商品中 【${content.length}】个不符合支付宝发布商品要求`,
          icon: createVNode(ExclamationCircleOutlined),
          content: createVNode("div", { style: "color:red" }, content),
          okText: "继续修改",
          cancelText: `忽略这【${content.length}】个商品，直接铺货`,
          cancelButtonProps: { type: "primary", danger: true },
          class: "taote-url-confirm-modal",
          onOk: () => resolve(true),
          onCancel: () => {
            const list = this.list.filter((item) => !idList.includes(item.id));
            if (!list.length) return this.$message.warning("已无合适的商品进行铺货");
            this.list = list;
            this.needUpdateList = [];
            handler.StartMove(this);
          },
        });
      });
    },
    // 点击【开始铺货】时执行
    async startMove() {
      this.loading = true;
      const errorArr = [],
        errorGoodsIds = [];
      this.needUpdateList = [];
      this.tip = "正在加载中，请耐心等待。";
      for (let i = 0; i < this.list.length; i++) {
        const nowGoodsItem = this.$refs.goodsItem[i];
        // 说明没有切换到分类tab中，则需要获取分类属性数据
        if (nowGoodsItem.initGoodsCategory) {
          nowGoodsItem.initGoodsCategory = false;
          await nowGoodsItem.$refs.GoodsCategory.getCategoryList();
          await nowGoodsItem.$refs.GoodsCategory.getCategoryProperty();
        }
        const item = this.list[i];
        if (!item) continue;
        let msg = "",
          key = "BaseInfo";
        if (!item.title.length) msg = " 商品标题是必须填写、";
        else if (this.getTitleLength(item.title) > 60) msg = "商品标题超过【60】个字符了、";
        if (!item.mainImages.length || item.mainImages.length < 3) msg += " 商品主图至少要有【3】张、";
        // if (!item.category?.length) {
        //   msg += ' 没有选择类目、'
        //   key = 'GoodsCategory'
        // }
        if (!item.detailImages.length) msg += " 商品详情图至少要有【1】张、";
        else if (item.detailImages?.length > 50) msg += " 商品详情图最多不能超过【50】张、";
        msg = handler.ValidateImage(item.mainImages, "商品主图", msg);
        msg = handler.ValidateImage(item.detailImages, "详情图", msg);
        const skuErrMsg = newSkuUtil.CheckSubmitSkuData(item);
        if (skuErrMsg) {
          msg += ` ${skuErrMsg}、`;
          key = "SkuInfo";
        }
        item.errorMsg = msg.slice(0, msg.length - 1);
        // 如果有错误信息
        if (msg) {
          const num = i + 1;
          errorArr.push(h("p", `第【${num}】个商品，ID：【${item.id}】，原因：${item.errorMsg}`));
          errorGoodsIds.push(item.id);
          item.errorMsg = `第【${num}】个商品，${item.errorMsg}`;
          item.activeKey = key;
          item.index = num;
          item.ref = nowGoodsItem;
          !this.needUpdateList.find((obj) => obj.id === item.id) && this.needUpdateList.push(item);
        }
      }
      if (errorArr.length) {
        this.loading = false;
        return this.showConfirm(errorArr, errorGoodsIds);
      }
      window.removeEventListener("keydown", this.keydownEvent);
      handler.StartMove(this);
    },
    // 返回顶部
    backTopTarget() {
      return document.querySelector(".shipping-preview .main");
    },
    // 批量修改商品类目
    async updateGoodsCategory({ category, selectType }) {
      let setTotal = 0;
      for (let i = 0; i < this.list.length; i++) {
        const item = this.list[i],
          goodsItem = this.$refs.goodsItem[i];
        // 两种, 勾选商品 或者是 未选择类目的商品
        if (
          (item.selected && selectType === "select-goods") ||
          (selectType === "goods-category-is-null" && !item.category?.length)
        ) {
          item.category = JSON.parse(JSON.stringify(category));
          goodsItem.initGoodsCategory = false;
          setTotal++;
        }
      }
      this.$message.success({ content: `批量修改 ${setTotal} 个商品的类目成功`, key: "xf_shanghuo_msg" });
      this.selectAllGoods(false);
    },
    keydownEvent(e) {
      const isPass =
        this.activeKey === "preview" &&
        !e.target.className?.includes("ant-input") &&
        !e.target.className?.includes("ant-select-selection-search-input") &&
        this.list?.length &&
        this.currentCheckedItem?.id;
      if (isPass) {
        const code = e.keyCode;
        const needScrollCodes = [38, 87, 40, 83, 68, 65];
        const index = this.list.findIndex((item) => item.id === this.currentCheckedItem.id);
        let needScrollToIndex = -1;
        if (code === 38 || code === 87) {
          // 上
          needScrollToIndex = this.list.findLastIndex((item, i) => !item.isUpdateData && i < index);
          // 如果是-1说明是要从尾开始
          needScrollToIndex = needScrollToIndex > -1 ? needScrollToIndex : this.list.length - 1;
        } else if (code === 40 || code === 83) {
          // 下
          needScrollToIndex = this.list.findIndex((item, i) => !item.isUpdateData && i > index);
          // 如果是-1说明是要从头开始
          needScrollToIndex = needScrollToIndex > -1 ? needScrollToIndex : 0;
        } else if (code === 68) {
          // 删除
          this.list.splice(index, 1);
          needScrollToIndex = this.list.findIndex((item, i) => !item.isUpdateData && i >= index);
          if (needScrollToIndex === -1)
            needScrollToIndex = this.list.findLastIndex((item, i) => !item.isUpdateData && i < index);
        } else if (code === 65) {
          // A 已修改
          needScrollToIndex = this.list.findIndex((item, i) => !item.isUpdateData && i > index);
          this.currentCheckedItem.isUpdateData = true;
        } else if (code === 9) {
          // Tab切换
          const activeKeyIndex = this.itemTabActivityList.findIndex(
            (item) => item.value === this.$refs.goodsItem[index].activeKey
          );
          this.$refs.goodsItem[index].activeKey = (
            this.itemTabActivityList[activeKeyIndex + 1] || this.itemTabActivityList[0]
          ).value;
        }
        if (needScrollToIndex > -1) {
          this.currentCheckedItem = this.list[needScrollToIndex];
          needScrollCodes.includes(code) &&
            handler.ScrollIntoView(
              document.querySelectorAll(this.itemClass)[needScrollToIndex],
              document.querySelector(this.mainClass),
              this.needUpdateList.length
            );
        }
        // 需要取消默认事件
        if (needScrollCodes.includes(code) || code === 9) e.preventDefault();
      }
    },
    addEvent() {
      window.addEventListener("keydown", this.keydownEvent);
    },
    getCategoryData() {
      this.getFirstCategoryList();
    },
  },
  watch: {
    // 重新铺货预览后要把原先的需要修改的商品数据清空
    list(val) {
      if (!val?.length) this.needUpdateList = [];
    },
  },
  mounted() {
    this.getCategoryData();
  },
};
</script>
<style scoped lang="less">
@import "./index";
</style>
